import { useState, useEffect } from "react";
import NandhuImg from "../../images/trainers/nandhu.png";
import {
  FaWhatsapp,
  FaPhone,
  FaArrowRight,
  FaTrophy,
  FaDumbbell,
  FaCertificate,
} from "react-icons/fa6";

function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const tickerItems = [
    "Weight Training",
    "Cardio Conditioning",
    "Personal Training (PT)",
    "Body Transformation",
    "Strength & Conditioning",
    "Functional Fitness",
    "Custom Diet & Nutrition",
    "Championship Coaching",
  ];

  return (
    <>
      <section
        id="home"
        className="relative w-full min-h-screen flex flex-col justify-between overflow-hidden bg-[#060608] text-white"
      >
        {/* ======================================================== */}
        {/* Dynamic Background: Ambient Neon Orbs & Cyber Grids */}
        {/* ======================================================== */}
        <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
          {/* Neon Red/Yellow/Purple Lighting Orbs */}
          <div className="absolute -top-32 -left-32 w-[550px] sm:w-[700px] h-[550px] sm:h-[700px] bg-red-600/15 rounded-full blur-[140px]"></div>
          <div className="absolute top-1/4 -right-32 w-[500px] sm:w-[650px] h-[500px] sm:h-[650px] bg-[#ffd600]/12 rounded-full blur-[140px]"></div>
          <div className="absolute bottom-10 left-1/3 w-[450px] sm:w-[600px] h-[450px] sm:h-[600px] bg-orange-600/10 rounded-full blur-[160px]"></div>

          {/* Subtle Cyber Perspective Grid Lines */}
          <div
            className="absolute inset-0 opacity-[0.05]"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.7) 1px, transparent 1px)",
              backgroundSize: "50px 50px",
            }}
          ></div>

          {/* Angular Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#060608]/40 to-[#060608]"></div>
        </div>

        {/* ======================================================== */}
        {/* Main Hero Container */}
        {/* ======================================================== */}
        <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-12 pt-36 sm:pt-44 lg:pt-48 pb-8 sm:pb-12 flex-1 flex items-center">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center w-full">
            
            {/* ── LEFT COLUMN: High Impact Typography & Direct CTAs (7 cols) ── */}
            <div
              className={`lg:col-span-7 text-center lg:text-left transition-all duration-1000 transform ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
              }`}
            >
              {/* Location Badge */}
              <div className="inline-flex items-center gap-2.5 bg-neutral-900/90 border border-neutral-800/80 rounded-full px-4 py-2 mb-6 sm:mb-8 backdrop-blur-md shadow-xl hover:border-brand-yellow transition-colors duration-300">
                <span className="flex h-2.5 w-2.5 relative">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#ff0336]"></span>
                </span>
                <span className="text-[11px] sm:text-[12.5px] uppercase font-extrabold tracking-widest text-neutral-200">
                  FAT2FIT UNISEX • ECHANARI, COIMBATORE
                </span>
              </div>

              {/* Main Powerful Headline */}
              <h1 className="font-black text-[34px] xs:text-[42px] sm:text-[54px] md:text-[62px] lg:text-[68px] leading-[1.05] tracking-tight mb-5 sm:mb-6 uppercase">
                <span className="text-white">TRANSFORM YOUR</span>
                <br />
                <span className="text-white">BODY. UNLEASH </span>
                <br className="hidden sm:inline" />
                <span className="bg-gradient-to-r from-[#ffd600] via-yellow-400 to-[#ff0336] bg-clip-text text-transparent drop-shadow-sm">
                  THE CHAMPION.
                </span>
              </h1>

              {/* Sub-headline */}
              <p className="text-neutral-300 text-[14px] sm:text-[16px] md:text-[17.5px] max-w-xl mx-auto lg:mx-0 mb-8 sm:mb-10 leading-relaxed font-medium">
                Train under <span className="text-[#ffd600] font-bold">Coach G. Nandha Kumar</span> — Mr. India Junior &amp; Mr. Tamil Nadu Champion. Experience premium heavy gear, tailored diets, and result-driven personal coaching.
              </p>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3.5 sm:gap-4 justify-center lg:justify-start max-w-md mx-auto lg:mx-0">
                <a
                  href="https://wa.me/918637488702?text=Hi%20Coach%20Nandha%2C%20I%20want%20to%20book%20a%20free%20trial%20session%20at%20FAT2FIT!"
                  target="_blank"
                  rel="noreferrer"
                  className="group relative inline-flex items-center justify-center gap-3 px-8 sm:px-9 py-4 font-bold text-[13px] sm:text-[14px] uppercase tracking-wider text-black bg-gradient-to-r from-[#ffd600] via-yellow-400 to-amber-500 rounded-xl shadow-xl shadow-yellow-500/20 hover:shadow-yellow-500/40 transition-all duration-300 transform hover:-translate-y-1"
                >
                  <FaWhatsapp className="text-[20px]" />
                  <span>Book Free Trial</span>
                  <FaArrowRight className="text-[12px] group-hover:translate-x-1 transition-transform" />
                </a>

                <a
                  href="tel:8637488702"
                  className="inline-flex items-center justify-center gap-2.5 px-7 py-4 font-bold text-[13px] sm:text-[14px] uppercase tracking-wider text-neutral-200 border-2 border-neutral-700 rounded-xl hover:border-brand-yellow hover:text-brand-yellow hover:bg-neutral-900/60 transition-all duration-300 backdrop-blur-sm"
                >
                  <FaPhone className="text-[14px]" />
                  <span>Call 8637488702</span>
                </a>
              </div>

              {/* Trust Indicators Stats Strip */}
              <div className="grid grid-cols-3 gap-3 sm:gap-6 mt-8 sm:mt-12 pt-6 border-t border-neutral-800/80 max-w-lg mx-auto lg:mx-0">
                <div className="text-center lg:text-left">
                  <div className="text-[22px] sm:text-[28px] md:text-[32px] font-black text-[#ffd600] leading-tight">
                    500+
                  </div>
                  <div className="text-neutral-400 text-[8px] sm:text-[7.5px] uppercase font-bold tracking-wider mt-0.5">
                    Transformations
                  </div>
                </div>
                <div className="text-center lg:text-left">
                  <div className="text-[22px] sm:text-[28px] md:text-[32px] font-black text-[#ff0336] leading-tight">
                    4+
                  </div>
                  <div className="text-neutral-400 text-[8px] sm:text-[7.5px] uppercase font-bold tracking-wider mt-0.5">
                    Gold Titles
                  </div>
                </div>
                <div className="text-center lg:text-left">
                  <div className="text-[22px] sm:text-[28px] md:text-[32px] font-black text-white leading-tight">
                    5.0 ★
                  </div>
                  <div className="text-neutral-400 text-[8px] sm:text-[7.5px] uppercase font-bold tracking-wider mt-0.5">
                    Google Rated
                  </div>
                </div>
              </div>
            </div>

            {/* ── RIGHT COLUMN: High Tech Showcase Visual (5 cols) ── */}
            <div
              className={`lg:col-span-5 relative flex items-center justify-center mt-4 lg:mt-0 transition-all duration-1000 delay-200 transform ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
              }`}
            >
              <div className="relative w-full max-w-[420px] lg:max-w-[480px] flex items-center justify-center">
                {/* Glowing Backlight Halo */}
                <div className="absolute w-[300px] sm:w-[380px] h-[300px] sm:h-[380px] rounded-full bg-gradient-to-tr from-[#ff0336]/35 via-[#ffd600]/25 to-transparent blur-3xl pointer-events-none"></div>

                {/* Rotating Tech Rings */}
                <div className="absolute w-[320px] sm:w-[410px] h-[320px] sm:h-[410px] rounded-full border border-neutral-800/90 pointer-events-none"></div>
                <div className="absolute w-[360px] sm:w-[460px] h-[360px] sm:h-[460px] rounded-full border border-dashed border-neutral-700/50 animate-spin-slow pointer-events-none"></div>

                {/* Coach Transparent Cutout Image */}
                <img
                  src={NandhuImg}
                  alt="Coach G. Nandha Kumar - Head Trainer"
                  className="relative z-10 w-auto h-[380px] xs:h-[440px] sm:h-[500px] lg:h-[560px] object-contain object-bottom drop-shadow-[0_25px_45px_rgba(0,0,0,0.95)]"
                />

                {/* Floating Card 1: Top Right (Championship Authority) */}
                <div className="absolute top-6 -right-2 sm:-right-6 z-20 bg-neutral-950/90 backdrop-blur-md border border-neutral-800 p-3 sm:p-4 rounded-2xl shadow-2xl animate-float">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#ffd600] to-amber-600 flex items-center justify-center text-black font-black text-[18px] shadow">
                      <FaTrophy />
                    </div>
                    <div className="text-left">
                      <div className="text-[12px] sm:text-[13px] font-black text-white uppercase tracking-tight">
                        G. Nandha Kumar
                      </div>
                      <div className="text-[10px] sm:text-[11px] font-bold text-[#ffd600]">
                        Mr. India Junior Champion
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floating Card 2: Bottom Left (Personal Training Result) */}
                <div className="absolute bottom-10 -left-2 sm:-left-6 z-20 bg-neutral-950/90 backdrop-blur-md border border-neutral-800 p-3 sm:p-4 rounded-2xl shadow-2xl animate-float animation-delay-2000">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#ff0336] to-pink-600 flex items-center justify-center text-white font-black text-[17px] shadow">
                      <FaDumbbell />
                    </div>
                    <div className="text-left">
                      <div className="text-[12px] sm:text-[13px] font-black text-white uppercase tracking-tight">
                        Personal Coaching
                      </div>
                      <div className="text-[10px] sm:text-[11px] font-bold text-neutral-400">
                        100% Result Driven
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Center Certificate Badge */}
                <div className="absolute -bottom-3 z-20 bg-black/90 border border-neutral-800 px-4 py-2 rounded-full flex items-center gap-2 shadow-2xl backdrop-blur-md">
                  <FaCertificate className="text-[#ffd600] text-[13px]" />
                  <span className="text-[11px] sm:text-[12px] font-bold text-white uppercase tracking-wider">
                    ICREPS Certified Fitness Centre
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ======================================================== */}
        {/* Athletic Ticker Marquee Bar */}
        {/* ======================================================== */}
        <div className="relative z-10 w-full bg-[#0a0a0d] border-t border-neutral-800/80 py-4 px-4 overflow-hidden">
          <div className="container mx-auto flex flex-wrap items-center justify-center sm:justify-around gap-4 sm:gap-6 text-neutral-400 text-[11px] sm:text-[12.5px] uppercase font-bold tracking-widest text-center">
            {tickerItems.map((item, idx) => (
              <span key={idx} className="flex items-center gap-2">
                <span className={`w-2 h-2 rounded-full ${idx % 2 === 0 ? "bg-[#ffd600]" : "bg-[#ff0336]"}`}></span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Hero;